'use client';
import AccountCard from '@/app/[locale]/(protected)/(dashboard)/ui/AccountCard';
import AccountSearchView from '@/app/[locale]/(protected)/(dashboard)/ui/AccountSearchView';
import { ITabConfig } from '@/app/[locale]/(protected)/(dashboard)/ui/TabTitleRender';
import { ReturnedAccount } from '@common/model/apiClient/Account';
import clsx from 'clsx';
import { ScrollView } from 'devextreme-react';
import React from 'react';
import styles from './TabView.module.css';

const searchSize = 10;

const AccountTabView = (props: { data: ITabConfig<ReturnedAccount> }) => {
  const { id } = props.data;
  const isSearchView = id === 'search';
  const viewClass = clsx(styles.view, { [styles.cardsView]: true });

  return (
    <div className={styles.wrapper}>
      <ScrollView showScrollbar={'onHover'} width={'100%'}>
        {/*{isSearchView && props.data.setSearch && <TextBox value={props.data.search} onValueChange={(v) => props.data.setSearch?.(v)} />}*/}
        {isSearchView ? (
          <AccountSearchView />
        ) : (
          <div className={viewClass}>
            {props.data.data.map((account) => (
              <AccountCard account={account} key={account.id} isCardView={true} />
            ))}
          </div>
        )}
      </ScrollView>
    </div>
  );
};

export default AccountTabView;
